var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRendement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.27 90.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dedede;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.26,0l-19,19h10.8v6.28A26.32,26.32,0,0,1,63,64H77.48V19H88.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.22,65.72A26.33,26.33,0,0,1,25.46,26.9H10.79V71.84H0l19,19,19-19H27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.13,22.63A22.88,22.88,0,1,0,67,45.5,22.87,22.87,0,0,0,44.13,22.63Zm2.4,19.1-.59,2.19H38.61c0,.43,0,.63,0,.87s0,.44,0,.87h6.87l-.59,2.19H39.22a7.15,7.15,0,0,0,6.23,4,6.43,6.43,0,0,0,4.37-1.66v3.35a8.68,8.68,0,0,1-4.37,1.09,9.64,9.64,0,0,1-9.22-6.75H33l.59-2.19h2.22c0-.43,0-.63,0-.87s0-.44,0-.87H33l.59-2.19h2.64A9.74,9.74,0,0,1,45.51,35,9.61,9.61,0,0,1,50,36.07l-.75,2.8a7,7,0,0,0-10.07,2.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRendement);
export default __webpack_public_path__ + "static/media/icon-rendement.f4899b4e9a7c085b8a379bebc359f977.svg";
export { ForwardRef as ReactComponent };